module.exports = "/_next/static/images/ico-fav-mini-35b8d0408a344ca1d1cd701d2878a92b.svg";